import { trackCategoriesLayoutElementView } from "@faire/web-api--source/events/categories/view/layoutElement";
import { trackHomeFeedLayoutElementView } from "@faire/web-api--source/events/homeFeed/view/layoutElement";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
export var logLegacyViewEvent = function(view_display_page, eventOptions) {
    var actionContent = eventOptions.actionContent.slice(0, 255);
    if (view_display_page === DisplayPageType.CATEGORY_PAGE) {
        trackCategoriesLayoutElementView(eventOptions.componentName, eventOptions.requestId, actionContent);
    } else if (view_display_page === DisplayPageType.HOMEPAGE) {
        trackHomeFeedLayoutElementView(eventOptions.componentName, eventOptions.requestId, actionContent);
    }
};
